import React, { useState, useEffect } from "react";
import { Typography, Input, Button, Card, message } from "antd";
import {
  LockOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone,
} from "@ant-design/icons";
import "./ResetPass.css";
import apiClient from "../utils/apiClient";

const { Title } = Typography;

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  /* ================= LOAD VERIFIED EMAIL ================= */
  useEffect(() => {
    const savedEmail = sessionStorage.getItem("reset_email");

    if (!savedEmail) {
      message.error("No verified email found. Please restart reset process.");
      return;
    }

    setEmail(savedEmail);
  }, []);

  /* ================= RESET PASSWORD ================= */
  const handleReset = async () => {
    if (!password || !confirmPassword) {
      message.error("Please fill all fields.");
      return;
    }

    if (password !== confirmPassword) {
      message.error("Passwords do not match.");
      return;
    }

    if (password.length < 6) {
      message.error("Password must be at least 6 characters.");
      return;
    }

    try {
      setLoading(true);

      // ✅ apiClient already returns parsed data
      const data = await apiClient("/auth/reset-password/", {
        method: "POST",
        body: JSON.stringify({
          email,
          password,
        }),
      });

      if (!data) {
        throw new Error("No response from server");
      }

      sessionStorage.removeItem("reset_email");

      message.success(
        "🎉 Password reset successful! Redirecting to login..."
      );

      setTimeout(() => {
        window.location.href = "/";
      }, 2000);

    } catch (err) {
      console.error("Reset password error:", err);

      message.error(
        err?.message ||
          "Failed to reset password. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  /* ================= UI ================= */
  return (
    <div className="reset-pass-container">
      <Card className="reset-pass-card" bordered={false}>
        <Title level={3} style={{ textAlign: "center" }}>
          Reset Password
        </Title>

        <Input.Password
          size="large"
          placeholder="New Password"
          prefix={<LockOutlined />}
          iconRender={(visible) =>
            visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
          }
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ marginBottom: 15 }}
        />

        <Input.Password
          size="large"
          placeholder="Confirm Password"
          prefix={<LockOutlined />}
          iconRender={(visible) =>
            visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
          }
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          style={{ marginBottom: 20 }}
        />

        <Button
          type="primary"
          block
          size="large"
          loading={loading}
          onClick={handleReset}
        >
          Reset Password
        </Button>
      </Card>
    </div>
  );
};

export default ResetPassword;
